import {required,numeric} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrPerfDonem = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrPerfDonemData:{
            Id: "",
            Aciklama: "",
            BaslamaTarihi: "",
            BitisTarihi: "",
            Deleted: false,
            Approval: false,
            Sira: 0,
            TipId: "",
            UstId: "",
            YilBas: 0,
            YilBit: 0,
            VeriTipi: 0,
            OlcumPeriyodu: null,

          },
        FormDataType:{ 
          Sira:{FieldName:"Sira",Field:"input",FieldTitle: this.$t('StrPerfDonem.AddEdit.Sira'),FieldType:"number"},
          UstId:{FieldName:"UstId",Field:"combobox",FieldTitle: this.$t('StrPerfDonem.AddEdit.UstId'),Disabled:"disabled",ComboDataArray:[]},
          TipId:{FieldName:"TipId",Field:"combobox",FieldTitle: this.$t('StrPerfDonem.AddEdit.TipId'),ComboDataArray:[]},
          YilBas:{FieldName:"YilBas",Field:"input",FieldTitle: this.$t('StrPerfDonem.AddEdit.YilBas'),FieldType:"number"},
          YilBit:{FieldName:"YilBit",Field:"input",FieldTitle: this.$t('StrPerfDonem.AddEdit.YilBit'),FieldType:"number"},
          Approval:{FieldName:"Approval",Field:"checkbox",FieldTitle: this.$t('StrPerfDonem.AddEdit.Approval')},
          Aciklama:{FieldName:"Aciklama",Field:"input",FieldTitle: this.$t('StrPerfDonem.AddEdit.Aciklama'),FieldType:"text"},
          BaslamaTarihi:{FieldName:"BaslamaTarihi",Field:"input",FieldTitle: this.$t('StrPerfDonem.AddEdit.BaslamaTarihi'),FieldType:"date"},
          BitisTarihi:{FieldName:"BitisTarihi",Field:"input",FieldTitle: this.$t('StrPerfDonem.AddEdit.BitisTarihi'),FieldType:"date"},
          VeriTipi:{FieldName:"VeriTipi",Field:"combobox",FieldTitle: this.$t('StrPerfDonem.AddEdit.VeriTipi'),ComboDataArray:[]},
          OlcumPeriyodu:{FieldName:"OlcumPeriyodu",Field:"combobox",FieldTitle:this.$t('StrPerfDonem.AddEdit.OlcumPeriyodu'),ComboDataArray:[]}
        },

        veritipleri: [
          { Id:"1",  Value:"Başlangıç" },
          { Id:"2",  Value:"Hedef" },
          { Id:"3",  Value:"Gerçekleşme" },
        ]
 
      }
    },
    validations:{ 
        FormData: {
            YilBas: { required,numeric },
            YilBit: { required,numeric },
            Aciklama: { required },
            BaslamaTarihi: { required },
            BitisTarihi: { required },
            TipId: { required },
            Approval: {},
            UstId: {},
            VeriTipi: {},
            Sira:{},
            OlcumPeriyodu: {}


        } 
    },


    created(){ 
      let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }
      this.ActionsGet({"Service":"StrPerfDonem","Page":Page}).then(res => {  
        for(var i=0; i<res.Data.length; i++)
          {
            this.FormDataType.UstId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama})
          }    
      }); 

          let Filter = "&Tip=1561";
            
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
                for(var i=0; i<res.Data.length; i++)
                {           
                    this.FormDataType.TipId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})   
                }
         
            });


            for(var i=0; i<this.veritipleri.length; i++)
            {
                this.FormDataType.VeriTipi.ComboDataArray.push ({Id:this.veritipleri[i].Id,Value:this.veritipleri[i].Value})
          
            }

            Filter = "&Tip=1556";
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
              for(var i=0; i<res.Data.length; i++)
                {
                    this.FormDataType.OlcumPeriyodu.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
                }
            });
      
    }



}
export default StrPerfDonem